import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { IconComponent } from '@mri-platform/ui-icon';
import { SvgIconName } from '@mri/elements-common';
import { PageHeaderToolbarButton, PageHeaderToolbarComponent } from './page-header-toolbar.component';

@Component({
  standalone: true,
  selector: 'mri-shared-page-header',
  imports: [IconComponent, NgTemplateOutlet, PageHeaderToolbarComponent],
  template: `
    <header class="mri-page-header">
      <h1 class="mri-heading mri-heading--1 mri-page-header__title">
        @if (eyeBrowTemplate) {
          <ng-container *ngTemplateOutlet="eyeBrowTemplate"></ng-container>
        } @else if (eyeBrowText) {
          <small class="mri-heading__eyebrow" [title]="eyeBrowTitle">
            {{ eyeBrowText }}
            @if (eyeBrowIcon) {
              <mri-icon-only [icon]="eyeBrowIcon"></mri-icon-only>
            }
          </small>
        }
        <span class="mri-heading__text">
          {{ pageName }}
        </span>
      </h1>
      <div class="mri-toolbar mri-page-header__toolbar mri-page-header__page-toolbar">
        <ng-content select="[primaryButtons]"></ng-content>
      </div>
      @if (toolbarTemplate || toolbarButtons) {
        <nav class="mri-page-header__nav mri-toolbar">
          <div class="mri-toolbar__group mri-page-header__toolbar mri-page-header__application-toolbar toolbar">
            @if (toolbarTemplate) {
              <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
            } @else if (toolbarButtons) {
              <mri-shared-page-header-toolbar [toolbarButtons]="toolbarButtons"></mri-shared-page-header-toolbar>
            }
          </div>
        </nav>
      }
    </header>
  `,
  styleUrl: 'page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent {
  @Input() pageName = '';
  @Input() eyeBrowText?: string;
  @Input() eyeBrowIcon?: SvgIconName;
  @Input() eyeBrowTitle = '';
  eyeBrowTemplate?: TemplateRef<HTMLElement>;
  toolbarTemplate?: TemplateRef<HTMLElement>;
  @Input() toolbarButtons?: PageHeaderToolbarButton[];
}
